module.exports = "<div style=\"margin:0 auto\"\r\n\tmax-width=\"lg\">\r\n\t<header class=\"padding-md ui-card\">\r\n\t\t<div class=\"margin-lg\">\r\n\t\t\t<h1 class=\"ui-title\">{{::$ctrl.data.Nombre}}</h1>\r\n\t\t\t<b>ID Cliente</b> {{::$ctrl.data.ID_Cliente}}\r\n\t\t</div>\r\n\t</header>\r\n\t<ui-view></ui-view>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/finanzas/_/bancosCuentas/detalle/template.html
// module id = 2883
// module chunks = 0